function importAll(rContext: __WebpackModuleApi.RequireContext) {
  rContext.keys().map((fileName: string) => ({
    slug: fileName.substr(2).replace(/\/index\.mdx$/, ''),
    module: rContext(fileName),
  }))
}

importAll(require.context('../../ico/', true, /\.svg$/));

importAll(require.context('../../images/', true, /^\.\/.*\.(jpe?g|png)/));
